import { connect } from 'react-redux';
import { Field, Label, Spinner, Subtitle1, Subtitle2, Title3 } from '@fluentui/react-components';

// component functions 
import * as ComponentFunctions from './StageFix.Form.Item.Functions';

// styles
import './StageFix.Form.Item.Styles.css';

// models
import { ProtocolVisit } from '../../../../../models/Entities/Protocols/ProtocolVisit';

// components
import ProtocolVisitSelectorComponent from '../../../../../commons/component/Inputs/ProtocolVisitsSelector/ProtocolVisitSelector.Component';
import { ArrowRight24Filled, ArrowTurnDownRight20Regular } from '@fluentui/react-icons';
import { FontSizes, Icon } from '@fluentui/react';
import { ContractStage } from '../../../../../models/Entities/Contracts/ContractStage';

const StageFormItemComponent = (props: ComponentFunctions.Props) => {


    const onChangeVisit = (contractVisit: ContractStage, crossVersionId: number) => {
        if (contractVisit) {
            props.LinkStageToAProtocolVisit(props.ProtocolId, contractVisit.contractId, contractVisit.contractAddendumId, contractVisit.id, crossVersionId);
        }
    }


    return (
        <Field className='FieldContainer'>
            <Subtitle2>{props.Stage.stageName}{props.isLinkingStage && <Spinner size='extra-tiny'/>}</Subtitle2>
            <div>
                <ArrowTurnDownRight20Regular />
                {props.ProtocolId && <ProtocolVisitSelectorComponent
                    ProtocolId={props.ProtocolId}
                    onSelectedVisit={(visit: ProtocolVisit[] | ProtocolVisit | undefined) => onChangeVisit(props.Stage, (visit as ProtocolVisit)?.crossVersionId)} 
                    SelectedVisitIds={props.Stage.emrProtocolVisitIdRelated ? [props.Stage.emrProtocolVisitIdRelated] : undefined} MultiselectEnable={false} />}
            </div>
        </Field>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(StageFormItemComponent as any);